import './filterButtonsGroup.scss'
import { Link } from 'react-router-dom'

const FilterButtonsGroup = ({ selectedLinkIndex, links }) => {
  return (
    <div className="filter-buttons-group">
      {links &&
        links.map((link, index) => (
          <Link
            to={link.url}
            key={index}
            className={`filter-button ${
              index === selectedLinkIndex ? 'selected' : ''
            }`}>
            {link.label}
          </Link>
        ))}
    </div>
  )
}

export default FilterButtonsGroup
